import type { ReactNode } from 'react'

export const FOCUS_VISIBLE_RING =
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cp-bright-blue'
export const ROW_HOVER_CLASS = 'hover:bg-cp-light-purple/70'
export const SEARCH_FOCUS_CLASS =
  'focus-within:border-cp-bright-blue focus-within:[outline-style:solid] focus-within:outline-1 focus-within:outline-offset-0 focus-within:outline-cp-bright-blue'

export function IconTile({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-light-grey bg-white">
      {children}
    </div>
  )
}

export function MatchBadge({ count }: Readonly<{ count: number }>) {
  if (count <= 0) return null
  return (
    <span
      className="rounded bg-cp-beta-bg px-1.5 py-0.5 text-xs leading-tight text-cp-beta-text whitespace-nowrap"
      data-testid="org-program-switcher-match-badge"
    >
      {count} match{count === 1 ? '' : 'es'}
    </span>
  )
}

export function SelectedBadge() {
  return (
    <span className="rounded bg-white px-1.5 py-0.5 text-[11px] leading-tight font-medium text-cp-bright-blue">
      Selected
    </span>
  )
}
